<template>
  <div id="about_section_wrap">
    <div>
      <div class="section centered">
        <h1 class="title lg">Hey, thanks for visiting.</h1>

        <h2
          class="subtitle"
          style="max-width: 500px; margin: auto; padding-top: 10px"
        >
          My name is Brandon. I’m a passionate software engineer, dog lover, and
          outdoor enthusiast. I love building interactive web applications,
          building software that solves real problems, and working with all
          kinds of data.
        </h2>
      </div>
    </div>
    <div id="business_card_section_wrap">
      <div id="business_card_section" class="section bini">
        <div class="alert">
          <p>
            Interested in working together?
            <strong class="green">Click</strong> my business card below and
            let's get started.
          </p>
        </div>
        <business-card
          :flipset="hasPreviousSubmission ? 2 : 0"
          v-model:flipped="flipped"
        >
          <template v-slot:front>
            <div class="business-card-innards">
              <h1 class="name">Brandon Aguirre</h1>
              <p class="position-title">Freelance Software Engineer</p>
              <p class="contact-info">www.brandonaguirre.com</p>
            </div>
          </template>
          <template v-slot:back>
            <div class="business-card-innards">
              <h1 class="name">
                {{ name
                }}<keyboard-typing
                  v-if="!name"
                  class="auto-type"
                  :text="['Haley Schisler', 'Karen Wozniak', 'Zack Pitchford']"
                />
              </h1>
              <p class="position-title">
                {{ position
                }}<keyboard-typing
                  v-if="name && !position"
                  class="auto-type"
                  :text="[
                    'Full Time Coffee Lover',
                    'CEO of Coolness',
                    'Outdoors Lover',
                  ]"
                />
              </p>
              <p class="contact-info">
                {{ email
                }}<keyboard-typing
                  v-if="name && position && !email"
                  class="auto-type"
                  :text="[
                    'youremail@gmail.com',
                    'funbiz@gmail.com',
                    'seacaptain@gmail.com',
                  ]"
                />
              </p>
            </div>
          </template>
        </business-card>
        <p v-if="hasPreviousSubmission">
          <strong class="green"
            >Thanks {{ thankName }}, I'll send you an email with my info
            momentarily!</strong
          >
        </p>
      </div>
      <div
        v-if="flipped && !hasPreviousSubmission"
        style="max-width: 500px; margin: auto"
      >
        <form
          id="contact_form"
          @submit.prevent="handleSubmit"
          class="row-nopad-container"
        >
          <div class="row">
            <label class="col-50" :class="{ error: errors.name }"
              >Name <span class="red" v-if="errors.name">*</span>
              <input
                name="name"
                placeholder="Your name"
                type="text"
                v-model="name"
              />
            </label>
            <label class="col-50" :class="{ error: errors.position }"
              >Position <span class="red" v-if="errors.position">*</span>
              <input
                name="position"
                placeholder="Your position"
                type="text"
                v-model="position"
              />
            </label>
          </div>
          <div class="row">
            <label class="col-50" :class="{ error: errors.email }"
              >Email <span class="red" v-if="errors.email">*</span>
              <input
                name="email"
                placeholder="youremail@gmail.com"
                type="email"
                v-model="email"
              />
            </label>
          </div>
          <div class="row">
            <label class="col-50"
              >Details
              <textarea
                rows="3"
                name="details"
                placeholder="Any notes or details?"
                v-model="notes"
              ></textarea>
            </label>
          </div>
          <div class="row">
            <div class="col">
              <button class="butt pull-right">Send</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BusinessCard from "@/components/BusinessCard";
import KeyboardTyping from "@/components/KeyboardTyping";
// import FeaturedArticle from '@/components/FeaturedArticle'
export default {
  name: "AboutSection",
  components: {
    BusinessCard,
    KeyboardTyping,
    // FeaturedArticle
  },
  data() {
    return {
      flipped: false,
      name: "",
      position: "",
      email: "",
      notes: "",
      errors: {},
      data: {},
      hasPreviousSubmission: false,
      localKey: "businessCardSubmission",
    };
  },
  computed: {
    thankName() {
      return this.name ? this.name.split(" ")[0] : this.name;
    },
  },
  methods: {
    flip(flipped) {
      if (flipped !== undefined) this.flipped = flipped;
      else this.flipped = !this.flipped;
    },
    handleSubmit(event) {
      this.data = {};
      this.errors = {};
      Array.prototype.forEach.call(event.target.elements, (el) => {
        if (el.localName === "input") {
          this.data[el.name] = el.value;
        }
      });
      for (let key of Object.keys(this.data)) {
        if (this.data[key] === "") {
          this.errors[key] = "Cannot leave field empty.";
        }
      }
      if (Object.keys(this.errors).length < 1) {
        if (process.env.NODE_ENV === "production") {
          let myForm = document.getElementById("contact_form");
          let formData = new FormData(myForm);
          fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: (() => {
              let params = new URLSearchParams(formData);
              params.append("form-name", "contact");
              return params.toString();
            })(),
          })
            .then(() => {
              this.storeLocal("data", this.data);
              this.hasPreviousSubmission = true;
            })
            .catch((error) => alert(error));
        } else {
          this.storeLocal("data", this.data);
          this.hasPreviousSubmission = true;
        }
      }
    },
    storeLocal(key, data) {
      window.sessionStorage.setItem(
        this.localKey + "/" + key,
        JSON.stringify(data),
      );
    },
    getLocal(key) {
      let ret;
      try {
        ret = JSON.parse(
          window.sessionStorage.getItem(this.localKey + "/" + key),
        );
      } catch (e) {
        ret = undefined;
      }
      return ret;
    },
  },
  mounted() {
    const data = this.getLocal("data");
    if (data) {
      this.name = data.name;
      this.email = data.email;
      this.position = data.position;
      this.hasPreviousSubmission = true;
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables";
p {
  font-size: 16px;
  line-height: $reading-line-height;
}

#about_section_wrap {
  padding-top: 50px; /* to make room for header */
  max-width: 1200px;
  margin: auto;
}

.section {
}

.bini {
  max-width: 400px;
  margin: auto;
  margin-top: 25px;
}

#business_card_section {
  margin-top: 50px;
}

.business-card-innards {
  text-align: center;

  .auto-type {
    color: #afafaf;
  }

  .name {
    margin-top: min(30px, 2vw);
    font-size: min(2rem, 8vw);
    font-family: "Pacifico", cursive;
    margin-bottom: 8px;
    line-height: min(35px, 9vw);
  }

  p.position-title,
  p.contact-info {
    font-weight: 300;
    margin: 0;
    font-size: min(0.9rem, 4vw);
    line-height: min(35px, 9vw);
  }

  p.position-title {
    margin-top: 1px;
    // margin-bottom: 50px;
  }
}

label {
  font-size: 0.8rem;

  &.error {
    > input {
      border-bottom: 1px solid red;
    }
  }

  .red {
    color: red;
  }
}

input {
  display: block;
  width: 100%;
  outline: none;
  border: 0;
  height: 30px;
  font-size: 1rem;
  border-bottom: 1px solid #222;
  margin: 0;
  padding: 0;
  border-radius: 0;
}

textarea {
  display: block;
  width: calc(100% - 6px);
  max-width: calc(100% - 6px);
  padding: 2px;
  border: solid 1px #222;
  font-size: 1rem;
  margin-top: 10px;
  font-family: "Roboto", sans-serif;
  height: auto;
}

.featured-article {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.green {
  color: $green;
}

// .alert {
//     color: blue;
//     background: lightblue;
//     box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.08);
//     border-radius: 5px;
//     padding: 10px 15px;
//     p {margin: 0;}
// }
</style>
